import * as React from "react";
import styled from "styled-components";

import { Text } from "../Text";

interface IProps {
  className?: string;
  legend: string;
  children: React.ReactChild[];
  /** If true marks fieldset as required, @default false*/
  required?: boolean;
}

const FieldsetStyled = styled("fieldset")``;

const Fieldset: React.ReactFCWithChildren<IProps> = ({
  className, legend, children, required = false
}) => {
  return (
    <FieldsetStyled className={className}>
      <Text
        as="legend"
        fontSize="h4"
        color="primary"
      >
        {legend}

        {required && (
          <RequiredAsterisk>
            {" "}
            *
          </RequiredAsterisk>
        )}
      </Text>

      {children}
    </FieldsetStyled>
  );
};

const RequiredAsterisk = styled("span")`
  color: ${({ theme }) => theme.colors.error};
`;

export default Fieldset;
